/*
 * @Description: 渠道数据 中文回显
 * @Author: mdb
 * @Date: 2022-07-27 16:38:35
 * @LastEditTime: 2022-09-21 14:57:10
 * @LastEditors: mdb
 */
import { usePermissionStore } from '@/stores/permission'
import type { ParamCodeItem } from '@/typings/common'
import useParamCode from '@/hooks/useParamCode'
const { getParamCodes } = useParamCode()

/**
 * 判断来源渠道是否不可编辑：
 * channel 在「市场推广」节点及其子孙节点中，且无 sale_edit_channel 权限时，返回 true
 */
export const isChannelDisabled = (
  nodes: ParamCodeItem[],
  channel: number | string | null | undefined
): boolean => {
  const permissionStore = usePermissionStore()
  const permissionBtn = permissionStore.permission
  console.log('permissionBtn:', permissionBtn.includes('sale_edit_channel_field'), permissionBtn)
  if (permissionBtn.includes('sale_edit_channel_field') || nodes.length === 0 || channel == null) {
    return false
  }

  const collectIds = (list: ParamCodeItem[]): string[] => {
    const result: string[] = []
    for (const node of list) {
      if (node.id != null) result.push(String(node.id))
      if (node.children?.length) result.push(...collectIds(node.children))
    }
    return result
  }

  const findMarketingNode = (list: ParamCodeItem[]): ParamCodeItem | undefined => {
    for (const node of list) {
      if (node.name === '市场推广') return node
      if (node.children?.length) {
        const found = findMarketingNode(node.children)
        if (found) return found
      }
    }
    return undefined
  }

  const marketingNode = findMarketingNode(nodes)
  const marketingIds = marketingNode ? collectIds([marketingNode]) : []
  return marketingIds.includes(String(channel))
}

const getTreeName = (tree: any, nodeId: any, config?: any) => {
  const { children = 'children', id = 'id', label = 'name' } = config || {}

  const toFlatArray = (tree: any, pid?: any) => {
    return tree.reduce((t: any, _: any) => {
      const child = _[children]
      return [...t, pid ? { ..._, pid } : _, ...(child && child.length ? toFlatArray(child, _[id]) : [])]
    }, [])
  }

  const getIds = (flatArray: any) => {
    let ids = [nodeId]
    let child = flatArray.find((_: any) => _[id] === nodeId)
    while (child && child.pid) {
      ids = [child.pid, ...ids]
      child = flatArray.find((_: any) => _[id] === child.pid)
    }
    const list = ids.map((id) => {
      const find = flatArray.find((e: any) => e.id === id)
      return find ? find[label] : nodeId // 若找不到，则直接返回传入的 id
    })
    return list
  }

  return getIds(toFlatArray(tree))
}

export default function () {
  const channelName = async (
    appid: 'cos_fbu' | 'cos_lbu' | 'cos_zbu',
    paramCode: string,
    channelId: number,
    explain?: string
  ): Promise<string> => {
    const paramCodeData = await getParamCodes(appid, paramCode)
    const channelNameList = getTreeName(paramCodeData, channelId).filter((name) => name)
    if (explain) channelNameList.push(explain)
    return channelNameList.join('/') || '--'
  }
  return { channelName }
}
